export default __webpack_public_path__ + "static/media/Flower arrangment2_primary.ea520283.jpg";